import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const putPSDetails = async (data) => {
  const response = await Axios.put(
    `${API_URL}/CarePlanWizardDetail/UpdatePersonalDetails`,
    data,
  );
  return response.data;
};

export { putPSDetails };
